import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// A little huddle of mushrooms — a pale tapered stalk + a lathe toadstool cap
// with a flared lip (rounded art style, plan 28 stage 4 — was a box + a cone).
const CAPS = [0xb5402f, 0xd98a3d, 0x8a5a3b];

// Geometry only — spawn metadata (weight/mapColor/habitat/sway/…) lives in
// content/decos/mushroom.json; this build is registered in src/model/coded.ts.
const build: (ctx: DecoBuildCtx) => void = ({ bone, lathe, seed }) => {
    const count = 1 + Math.floor(rand(seed) * 3);
    const cap = CAPS[Math.floor(rand(seed + 1) * CAPS.length)]!;
    for (let i = 0; i < count; i++) {
      const a = rand(seed + i * 6) * Math.PI * 2;
      const r = rand(seed + i * 6 + 1) * 0.3;
      const x = Math.cos(a) * r, z = Math.sin(a) * r;
      const h = 0.18 + rand(seed + i * 6 + 2) * 0.22; // stalk height
      const w = 0.16 + rand(seed + i * 6 + 3) * 0.12; // cap width
      const capH = w * 0.7;
      const capCol = shade(cap, (rand(seed + i) - 0.5) * 0.2);
      // stalk (wider at base) — base endpoint lifted by r0 so its rounded foot
      // rests ON the ground (bottom cap bottoms out at y≈0), not sunk under it.
      bone(x, w * 0.24, z, x, h, z, w * 0.24, w * 0.17, 0xeadfc8);
      // dome cap: flared lip near the base, pulling in to a closed pole up top
      lathe(x, h - 0.02, z,
        [[w * 0.55, 0], [w, capH * 0.25], [w * 0.7, capH * 0.7], [0, capH]],
        capCol, undefined, 10);
    }
  };

export default build;
